const round2Decimals = (number) => {
    let number100 = number * 100
    let numberTruncate = Math.round(number100)
    return numberTruncate / 100
}

export default round2Decimals